<template src="./user-create.html">
</template>
<script>
  import Vue from 'vue'
  import { EventBus } from '@/router/bus'
  import Vuelidate from 'vuelidate'
  import { validationMixin } from '@/mixins/validation'
  import { required } from 'vuelidate/lib/validators'
  import Loader from '@/components/misc/Loader'

  Vue.use(Vuelidate)

  export default {
    name: 'user-create',
    components: {Loader},
    mixins: [validationMixin],
    data () {
      return {
        load: false,
        availableRoles: [],
        selectedRoles: [],
        availableClaims: [],
        selectedClaims: [],
        user: {
          login: '',
          name: '',
          email: ''
        }
      }
    },
    created: function (e) {
      let roles = Vue.$config.user_roles

      for (let i = 0; i < roles.length; i++) {
        let role = {}
        role.text = this.$t('userAdministration.' + roles[i])
        role.value = roles[i]
        this.availableRoles.push(role)
      }

      this.selectedRoles.push(this.availableRoles[1].value)
      let claims = Vue.$config.user_claims

      for (let i = 0; i < claims.length; i++) {
        let claim = {}
        claim.text = this.$t('userAdministration.' + claims[i])
        claim.value = claims[i]
        this.availableClaims.push(claim)
      }
    },
    methods: {
      validateBeforeCreateUser () {
        this.logConsole(this.user)
        this.$v.$touch()
        if (this.$v.$invalid) {
          EventBus.$emit('alert', {
            variant: 'danger',
            message: this.$t('errors.someErrorsOccuredCheckListBelow'),
            errors: this.getValidationErrors('user')
          })
          return
        }
        this.createUser()
        this.logConsole('Submitted')
      },
      createUser () {
        this.load = true
        this.user.creationRoles = this.selectedRoles
        this.user.creationClaims = this.selectedClaims
        this.$http.post(Vue.$apiConfig.createLocalUserPost, this.user)
          .then(response => {
            this.logConsole(response)
            EventBus.$emit('alert', {
              variant: 'success',
              message: this.$t('userAdministration.userCreated'),
              errors: []
            })
            this.$refs.createUserForm.reset()
            this.load = false
          }, error => {
            this.logConsole(error)
            this.formatErrorResponse(error)
            this.load = false
          })
      }
    },
    validations: {
      user: {
        login: {
          required
        },
        name: {
          required
        },
        email: {
          required
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// UserCreate.vue?2d2db1a6